package music.jammers.client.shared.event.data.repository

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.delete
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import music.jammers.client.shared.event.domain.repository.EventRepository
import music.jammers.shared.event.domain.model.Event
import music.jammers.shared.event.domain.model.EventData
import music.jammers.shared.event.domain.model.EventDetails
import music.jammers.shared.event.domain.model.EventFreezeData
import music.jammers.shared.event.domain.model.UserAcceptance

class EventRepositoryImpl(
    private val client: HttpClient,
) : EventRepository {

    override suspend fun get(id: Long): Event = client.get("events/$id").body()

    override suspend fun getAll(): List<Event> = client.get("events").body()

    override suspend fun create(eventDataModel: EventData): Event = client.post("events") {
        contentType(ContentType.Application.Json)

        setBody(eventDataModel)
    }.body()

    override suspend fun delete(eventId: Long) {
        client.delete("events/$eventId")
    }

    override suspend fun getDetails(eventId: Long): EventDetails =
        client.get("events/$eventId/details").body()

    override suspend fun update(eventId: Long, eventData: EventData): Event =
        client.put("events/$eventId") {
            contentType(ContentType.Application.Json)

            setBody(eventData)
        }.body()

    override suspend fun freeze(eventId: Long, freezeData: EventFreezeData): EventDetails =
        client.post("events/$eventId/freeze") {
            contentType(ContentType.Application.Json)

            setBody(freezeData)
        }.body()

    override suspend fun sort(eventId: Long): EventDetails =
        client.get("events/$eventId/sort").body()

    override suspend fun getAcceptance(eventId: Long): UserAcceptance =
        client.get("events/$eventId/acceptance").body()
}